<template>
  <el-card>
    <div slot="header">
      Árak
    </div>
    <el-form
      ref="pricingForm"
      :model="pricing"
      label-position="top"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Alapár"
            prop="price"
          >
            <el-input-localized-numeric
              v-model="pricing.price"
            >
              <template slot="append">Ft</template>
            </el-input-localized-numeric>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Padló ár"
            prop="minimum_price"
          >
            <el-input-localized-numeric
              v-model="pricing.minimum_price"
            >
              <template slot="append">Ft</template>
            </el-input-localized-numeric>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Kisker ár"
            prop="retailer_price"
          >
            <el-input-localized-numeric
              v-model="pricing.retailer_price"
            >
              <template slot="append">Ft</template>
            </el-input-localized-numeric>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Web ár"
            prop="web_price"
          >
            <el-input-localized-numeric
              v-model="pricing.web_price"
            >
              <template slot="append">Ft</template>
            </el-input-localized-numeric>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Beszerzési ár"
            prop="purchase_price"
          >
            <el-input-localized-numeric
              v-model="pricing.purchase_price"
            >
              <template slot="append">Ft</template>
            </el-input-localized-numeric>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Áfa"
            prop="vat_id"
          >
            <el-select
              v-model="pricing.vat_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="vat in vats"
                :key="vat.id"
                :label="`${vat.value}%`"
                :value="vat.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
export default {
  props: ['product'],
  data() {
    return {
      pricing: {
        minimum_price: 0,
        price: 0,
        purchase_price: 0,
        retailer_price: 0,
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Név megadása kötelező',
            trigger: 'change'
          }
        ],
      }
    };
  },
  computed: {
    vats() {
      return this.$store.getters['vat/vats'];
    },
  },
  watch: {
    product(newVal) {
      this.pricing = {
        minimum_price: newVal.minimum_price || 0,
        price: newVal.price || 0,
        purchase_price: newVal.purchase_price || 0,
        retailer_price: newVal.retailer_price || 0,
        web_price: newVal.web_price || 0,
        vat_id: newVal.vat_id,
      };
    },
  },
};
</script>
